import * as GroupType from 'constants/GroupType';

const VOLLEYBALL_GROUP_MAP = {};

VOLLEYBALL_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
VOLLEYBALL_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
VOLLEYBALL_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
VOLLEYBALL_GROUP_MAP[3] = GroupType.THIRD_PERIOD_GROUP;
VOLLEYBALL_GROUP_MAP[4] = GroupType.FOURTH_PERIOD_GROUP;
VOLLEYBALL_GROUP_MAP[5] = GroupType.FIFTH_PERIOD_GROUP;
VOLLEYBALL_GROUP_MAP[6] = GroupType.SIXTH_PERIOD_GROUP;
VOLLEYBALL_GROUP_MAP[7] = GroupType.FIRST_PERIOD_TEN_POINTS_MINI_MATCH_GROUP;
VOLLEYBALL_GROUP_MAP[8] = GroupType.FIRST_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP;
VOLLEYBALL_GROUP_MAP[9] = GroupType.SECOND_PERIOD_TEN_POINTS_MINI_MATCH_GROUP;
VOLLEYBALL_GROUP_MAP[10] = GroupType.SECOND_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP;
VOLLEYBALL_GROUP_MAP[11] = GroupType.THIRD_PERIOD_TEN_POINTS_MINI_MATCH_GROUP;
VOLLEYBALL_GROUP_MAP[12] = GroupType.THIRD_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP;
VOLLEYBALL_GROUP_MAP[13] = GroupType.FOURTH_PERIOD_TEN_POINTS_MINI_MATCH_GROUP;
VOLLEYBALL_GROUP_MAP[14] = GroupType.FOURTH_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP;

export default VOLLEYBALL_GROUP_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Volleyball/GroupMap.js